import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styled from 'styled-components';

const PageContainer = styled.div`
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
`;

const Card = styled.div`
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 90%;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
`;

const Message = styled.p`
  color: #666;
  margin-bottom: 24px;
`;

const GoogleCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setAuthToken } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const success = searchParams.get('success');
    const error = searchParams.get('error');

    if (success === 'true' && token) {
      // HTTP-only cookies are set by the backend, refresh auth context
      setAuthToken(token);

      // Fetch user profile to update auth context
      // The AuthContext will handle this automatically on next render
      setTimeout(() => {
        navigate('/');
      }, 1000);
    } else if (error) {
      // Handle error
      setTimeout(() => {
        navigate(`/login?error=${error}`);
      }, 2000);
    } else {
      // No token or success, redirect to login
      setTimeout(() => {
        navigate('/login?error=google_auth_failed');
      }, 2000);
    }
  }, [searchParams, navigate, setAuthToken]);

  const token = searchParams.get('token');
  const success = searchParams.get('success');
  const error = searchParams.get('error');

  if (success === 'true' && token) {
    return (
      <PageContainer>
        <Card>
          <Title>Success!</Title>
          <Message>You have been successfully signed in with Google. Redirecting...</Message>
        </Card>
      </PageContainer>
    );
  }

  if (error) {
    return (
      <PageContainer>
        <Card>
          <Title>Authentication Failed</Title>
          <Message>There was an error signing in with Google. Redirecting to login...</Message>
        </Card>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <Card>
        <Title>Processing...</Title>
        <Message>Please wait while we complete your sign in.</Message>
      </Card>
    </PageContainer>
  );
};

export default GoogleCallbackPage;

